import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "z-50 absolute left-1/2 top-0 py-5 w-screen h-full max-w-[400px] flex items-end pointer-events-none" }
const _hoisted_2 = { class: "max-h-full bg-white p-5 rounded overflow-y-auto w-full pointer-events-auto" }


const __default__ = {
  inheritAttrs: false,
};

import {
  NkButton,
  NkCenter,
  NkDivider,
  NkGroup,
  NkOSDOverlay,
  NkOSDOverlayMeasure,
  NkStack
} from '@/core/components';
import { StOSDOverlayBackground } from '@/core/components/data-display/OSD/osd.styled';
import { useGetInspectionQuery } from '@/entities/inspection/hooks';
import {
  computed,
  inject,
  onBeforeUnmount,
  onMounted,
  provide,
  ref,
} from 'vue';
import InspectionViewerCreateAnnotationForm
  from '@/teams/visionair/components/InspectionViewer/InspectionViewerCreateAnnotationForm.vue';
import InspectionViewerCreateAnnotationLinkForm
  from '@/teams/visionair/components/InspectionViewer/InspectionViewerCreateAnnotationLinkForm.vue';
import {
  InspectionViewerCreateAnnotationFormInjection,
  inspectionViewerCreateAnnotationFormInjectionKey,
  InspectionViewerCreateAnnotationFormProps,
  inspectionViewerCreateAnnotationFormProps,
  InspectionViewerInjection,
  inspectionViewerInjectionKey,
} from '@/teams/visionair/components/InspectionViewer/inspection-viewer.shared';
import store from "@/store";
import InspectionViewerCreateAnnotationFormSherlock
  from '@/teams/visionair/components/InspectionViewer/InspectionViewerCreateAnnotationFormSherlock.vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'InspectionViewerCreateAnnotationFormGroup',
  props: inspectionViewerCreateAnnotationFormProps,
  emits: ['cancel', 'submitted'],
  setup(__props, { emit }) {

const p = __props



const injectedInspectionViewer = inject(inspectionViewerInjectionKey) as InspectionViewerInjection;


const props = p as unknown as InspectionViewerCreateAnnotationFormProps;
provide<InspectionViewerCreateAnnotationFormInjection>(inspectionViewerCreateAnnotationFormInjectionKey, {
  props,
  emit,
});

const inspectionQueryData = computed(() => ({ id: props.inspection }));
const hasInspectionQueryData = computed(() => !!inspectionQueryData.value.id);
const { data: inspection } = useGetInspectionQuery(inspectionQueryData, { enabled: hasInspectionQueryData });

const annotations = computed(() => inspection.value?.annotations || []);

const centerView = () => {
  injectedInspectionViewer.centerFormView(props.completeLocation.viewportLocation);
};

onMounted(() => {
  centerView();
});

onBeforeUnmount(() => {
  if (injectedInspectionViewer) {
    injectedInspectionViewer.setHoveredAnnotation(null);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NkOSDOverlay), {
      options: {location: _unref(props).completeLocation.viewportLocation}
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(StOSDOverlayBackground), {
          active: true,
          class: "w-full h-full",
          service: _ctx.$store.getters['service/service']
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NkCenter), { class: "h-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(NkButton), {
                  circle: "",
                  class: "pointer-events-none",
                  icon: "NkComment"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["service"])
      ]),
      _: 1
    }, 8, ["options"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(NkStack), { spacing: 5 }, {
          default: _withCtx(() => [
            _createVNode(_unref(NkGroup), { position: "apart" }, {
              default: _withCtx(() => [
                _createVNode(_unref(NkButton), {
                  circle: "",
                  icon: "NkVisibility",
                  type: "white",
                  onClick: centerView
                }),
                _createVNode(_unref(NkButton), {
                  circle: "",
                  icon: "NkClose",
                  type: "white",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(NkDivider)),
            ([3,4,7].includes(_ctx.$store.getters['service/service']))
              ? (_openBlock(), _createBlock(InspectionViewerCreateAnnotationFormSherlock, _normalizeProps(_mergeProps({ key: 0 }, _ctx.$props)), null, 16))
              : (_openBlock(), _createBlock(InspectionViewerCreateAnnotationForm, _normalizeProps(_mergeProps({ key: 1 }, _ctx.$props)), null, 16)),
            _createVNode(_unref(NkDivider), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('misc.or')), 1)
              ]),
              _: 1
            }),
            _createVNode(InspectionViewerCreateAnnotationLinkForm, _normalizeProps(_guardReactiveProps(_ctx.$props)), null, 16)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})